export const RECEIVE_PRESS = "adminPress/RECEIVE_PRESS";

export const EDIT_PRESS_PROP = "adminPress/EDIT_PRESS_PROP";